import { request } from 'utils/request';
import * as L from 'leaflet';

const mapApi = {
  getPolygons: (
    envId: number,
    seasonId: number,
    companyId: number | null,
    companyGroupId: number | null,
  ) => {
    const defaultParameters: {
      hiiko_environment_id: number;
      season_id: number;
      service: string;
      version: string;
      request: string;
      typename: string;
      srsName: string;
      outputFormat: string;
      company_id?: number;
      company_group_id?: number;
    } = {
      hiiko_environment_id: envId,
      season_id: seasonId,
      service: 'WFS',
      version: '1.1.0',
      request: 'GetFeature',
      typename: 'nyc:field_season_view', // nyc:nyc_buildings_area_view
      // srsName: 'EPSG:2908',
      // srsName: 'EPSG:3857',
      srsName: 'EPSG:4326', // world
      outputFormat: 'application/json',
    };
    if (companyId) {
      defaultParameters.company_id = companyId;
    }
    if (companyGroupId) {
      defaultParameters.company_group_id = companyGroupId;
    }
    const rootUrl = 'geoserver/wfs';
    const params = L.Util.extend(defaultParameters);
    const url = rootUrl + L.Util.getParamString(params);

    return request({ url });
  },

  getAdministrativeFields: (envId: number, seasonId: number) => {
    const params = {
      request: 'GetFeature',
      service: 'WFS',
      typeName: 'importuoti_sluoksinai:Administraciniai_laukai',
      version: '1.0.0',
      outputFormat: 'application/json',
      maxFeatures: 100,
      layer_preview: true,
      hiiko_environment_id: envId,
      season_id: seasonId,
      srsName: 'EPSG:4326',
      srs: 'EPSG:4326',
      // bbox:
      //   '56.09707181,22.10655371,56.39707181,22.68746292,urn:ogc:def:crs:EPSG:4326',
    };
    return request({
      url: 'geoserver/ows',
      params,
    });
  },
  getFieldCultureVariationsByUsedResource: ({
    envId,
    fieldSeasonIds,
  }: {
    envId: number;
    fieldSeasonIds: number[];
  }) => {
    return request({
      url: `hiiko_environment/${envId}/field-seasons/culture_variation_by_used_resources`,
      params: { field_season_ids: fieldSeasonIds.join(',') },
    });
  },
};

export default mapApi;
